import React from 'react';
import { Translate } from 'react-redux-i18n';
import logo from '../../../img/logo-idnot.png';
import { getLinks } from '../../../network/api/links';
import Button from '../../common/Button';
import Footer from '../../layout/Footer';

function AccountAlreadyActivated(): React.ReactElement {
  return (
    <div className="activation-link-page">
      <div className="activation-header">
        <div className="label-container">
          <div className="main-content">
            <div>
              <img className="logo" src={logo} alt="logo" />
            </div>
            <div>
              <h3>
                <Translate value="ACTIVATION.TITLE" />
              </h3>
              <div className="subtitle">
                <Translate value="HEADER.UNIQUE_ACCOUNT" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="email-page-content">
        <h3><Translate value="ACCOUNT_ACTIVATED.TITLE" /></h3>
        <div className="back-button">
          <a
            aria-label="Se connecter"
            href={getLinks().connectionLink}
          >
            <Button
              type="third"
              i18nKey="HEADER.CONNECTION"
            />
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AccountAlreadyActivated;
